package dev.alimmz.portfolio.presentation.theme

import androidx.compose.ui.graphics.Color

val AndroidGreen = Color(0xFF9EE65B)
val DarkGreen = Color(0xFF073042)
val TextGray = Color(0xFF4A4A4A)
val BackgroundWhite = Color(0xFFFFFFFF)

// Cozy Design Palette
val CozyCream = Color(0xFFFAF9F6)
val CozyBeige = Color(0xFFE9EDE1)
val CozyPeach = Color(0xFFFFE5D9)
val CozyOrange = Color(0xFFFF9B71)
val CozySage = Color(0xFFB4C5A1)
val CozyInk = Color(0xFF2D2D2D)
val CozySoftGray = Color(0xFF8E8E93)

// Keeping legacy names for theme compatibility
val LightWhite = CozyCream
val PureWhite = Color.White
val SurfaceWhite = CozyBeige
val StudioBlack = CozyInk
val StudioGray = CozySoftGray
val StudioWhite = CozyCream
val AccentGreen = AndroidGreen
val SoftGray = CozySoftGray
val GlassWhite = Color(0x1AFFFFFF)
val PaperWhite = CozyCream
val InkBlack = CozyInk
val MutedGreen = CozySage
val BorderColor = Color(0xFFE5E5E5)

val PortfolioLightBackground = Color(0xFFF5F4EE)
val PortfolioLightSurface = Color(0xFFFFFFFF)
val PortfolioLightSurfaceVariant = Color(0xFFE9EDE1)
val PortfolioLightTextPrimary = Color(0xFF242A27)
val PortfolioLightTextSecondary = Color(0xFF535D58)
val PortfolioLightOutline = Color(0xFFD4DBD6)
val PortfolioLightAccentContainer = Color(0xFFFFE5D9)

val PortfolioDarkBackground = Color(0xFF101810)
val PortfolioDarkSurface = Color(0xFF192319)
val PortfolioDarkSurfaceVariant = Color(0xFF222925)
val PortfolioDarkTextPrimary = Color(0xFFF1F5F2)
val PortfolioDarkTextSecondary = Color(0xFFC5CEC9)
val PortfolioDarkOutline = Color(0xFF46524C)
val PortfolioDarkAccentContainer = Color(0xFF3B2922)

